import {
  GET_ALL_ADMIN_PRODUCT,
  GET_PRODUCT_ALL,
  GET_ALL_WHO_PRODUCT,
} from '../types'

const INITIAL_STATE = {
  getAllProductAdmin: [],
  getOneProductInfo: {},
  getWhoProduct: [],
}

const productReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_ALL_ADMIN_PRODUCT:
      return {
        ...state,
        getAllProductAdmin: payload.data,
      }
    case GET_PRODUCT_ALL:
      return {
        ...state,
        getOneProductInfo: payload.data,
      }

    case GET_ALL_WHO_PRODUCT:
      return {
        ...state,
        getWhoProduct: payload.data,
      }
    default:
      return state
  }
}

export default productReducer
